import { useEffect, useState } from "react";

export const breakpoints = {
  xs: "(max-width: 479px)",
  sm: "(min-width: 480px) and (max-width: 959px)",
  md: "(min-width: 960px) and (max-width: 1919px)",
  lg: "(min-width: 1920px)",
};

export const specificBreakpoints = {
  small: "(max-width: 479px)",
  xSmall: "(min-width: 480px) and (max-width: 599px)",
  smallMedium: "(min-width: 600px) and (max-width: 767px)",
  smallLarge: "(min-width: 768px) and (max-width: 959px)",
  medium: "(min-width: 960px) and (max-width: 1069px)",
  mediumWide: "(min-width: 1070px) and (max-width: 1279px)",
  large: "(min-width: 1280px) and (max-width: 1439px)",
  largeMedium: "(min-width: 1440px) and (max-width: 1919px)",
  xLarge: "(min-width: 1920px)",
};

/**
 * @deprecated use breakpoints defintions
 */
export const deprecatedBreakpoints = {
  small: "(max-width: 480px)",
  medium: "(min-width: 481px) and (max-width: 960px)",
  large: "(min-width: 961px)",
};

const getBreakpoint = <T extends Record<string, string>>(breakpoints: T) => {
  return Object.keys(breakpoints).find((breakpoint) => window.matchMedia(breakpoints[breakpoint]).matches) as keyof T;
};

/**
 * @deprecated use `useDeviceBreakpoint` hook instead
 */
export const useCurrentBreakpoint = () => {
  const [currentBreakpoint, setCurrentBreakpoint] = useState<keyof typeof deprecatedBreakpoints>("large");
  const [mainBreakpoint, setMainBreakpoint] = useState<keyof typeof breakpoints>("lg");
  const [specificBreakpoint, setSpecificBreakpoint] = useState<keyof typeof specificBreakpoints>("xLarge");

  useEffect(() => {
    const handleResize = () => {
      setCurrentBreakpoint(getBreakpoint(deprecatedBreakpoints));
      setMainBreakpoint(getBreakpoint(breakpoints));
      setSpecificBreakpoint(getBreakpoint(specificBreakpoints));
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isLarge = currentBreakpoint === "large";
  const isMedium = currentBreakpoint === "medium";
  const isSmall = currentBreakpoint === "small";

  return {
    /**
     * @deprecated use mainBreakpoint instead
     */
    isLarge,
    /**
     * @deprecated use mainBreakpoint instead
     */
    isMedium,
    /**
     * @deprecated use mainBreakpoint instead
     */
    isSmall,
    /**
     * @deprecated use mainBreakpoint/specificBreakpoint
     */
    currentBreakpoint,
    mainBreakpoint,
    specificBreakpoint,
  };
};
